/* eslint-disable no-nested-ternary,import/no-unresolved */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useEffect, useRef, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import ReactCardFlip from 'react-card-flip';
import { isMobile } from 'react-device-detect';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import { ActiveCardBack, VirtualCardBack, MAIN_ICON_COLORS } from 'assets/components';
import BigNumber from 'bignumber.js';
import { Card, CardOptions, CardTransactions } from './partials';
import ActivateCardModal from '../../modules/modals/ActivateCardModal';
import {
  cardFlipTargets,
  cardPopups,
  cardProviders,
  CardState,
  manageCardScreens,
  resolveCardFlipTarget,
  resolveCardNetwork,
  shouldShowActivateAlert,
} from './constants';
import CardLayout from '../shared/CardLayout';
import {
  PASSWORD_PUBLIC_KEY,
  RATES_QUERY_KEY,
  SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  USER_PREFERENCES,
  USER_REGION_SETTINGS_QUERY_KEY,
} from '../../utilities/sharedQueries';
import { WALLETS_ALL } from '../Accounts/queries';
import {
  CARD_INTEREST_PAYMENT_CRYPTODRAFT,
  CARD_CRYPTODRAFT,
  CARD_LINKED_WALLETS,
  CARD_LOAD_CASHBACK,
  MASTERCARD_MONAVATE_DETAILS,
  CARD_MONAVATE_PIN_CHECK,
} from './queries';
import {
  useCardStatus,
  useUserCardProvider,
  useCardBalances,
} from '../../utilities/sharedHooks/user';
import {
  useLedgerFilteredAllowedCreationCurrencies,
  useLedgerFilteredWallets,
} from '../../utilities/sharedHooks/ledgerWallets';
import CardCryptodraftDetails from './partials/CardCryptodraftDetails';
import CardInfoBanner from './partials/CardInfoBanner';
import CardTransactionDetailsModal from './modals/TransactionDetailsModal';
import ViewCvvAndPanModal from '../../modules/modals/ViewCvvAndPanModal';
import CardSettingsModal from '../../modules/modals/CardSettingsModal';
import EnableCardModal from './modals/EnableCardModal';
import { currencies, exchange, loyaltyScreens } from '../../utilities/constants';
import { formatNumber } from '../../utilities/formatHelpers';
import useIsUsUser from '../../utilities/sharedHooks/usUser';
import CardGalileoBackSideModal from '../../modules/modals/CardGalileoBackSideModal';
import CardConnectFinancialDetailsModal from '../../modules/modals/CardConnectFinancialDetailsModal';
import LoyaltyProgram from './loyaltyProgram';
import LoyaltyProgramNewUi from './loyaltyProgramNewUi';
import LoyaltyProgramModal from './modals/LoyaltyProgramModal';
import { showAlert } from '../../utilities/notifications';
import { useRate } from '../../utilities/sharedHooks/rates';
import { useSetting } from '../../utilities/sharedHooks/settings';
import { BANK_REQUESTS_COINS } from '../Accounts/constants';
import ModalLayout from '../shared/ModalLayout';
import InfoPopup from '../shared/Modals/InfoPopup';
import {
  cacheUserBannerInfo,
  getUserBannerInfo,
  getShowCardHint,
  getCryptodraftBannerInfo,
  hideCryptodraftBannerInfo,
} from '../../utilities/caching';
import { cryptodraftScreens } from './Cryptodraft/constants';
import PaymentBanner from './partials/PaymentBanner';
import { cardSettingsScreens } from './Settings/constants';
import { encryptWithPublicKey } from '../../utilities/helpers';
import { SettingButtonPlaceholder } from '../../components/Placeholders';
import { useUsEnv } from '../../utilities/sharedHooks/useUsEnv';

const CardManager = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const isUsUser = useIsUsUser();
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [password, setPassword] = useState('');
  const [encryptedPassword, setEncryptedPassword] = useState('');

  const [isShowingActivateFLow, setIsShowingActivateFlow] = useState(false);
  const [isShowingGetCvvAndPanModal, setIsShowingGetCvvAndPanModal] = useState(false);
  const [isShowingPinModal, setIsShowingPinModal] = useState(false);
  const [allowCryptodraftFeature] = useSetting('app_features', 'feature_allow_cryptodraft');

  const { cardProvider, isLoading: isLoadingCardProvider } = useUserCardProvider();

  const { state: locationState } = useLocation();
  const [isGalileoCardReady, setIsGalileoCardReady] = useState(false);

  const { isUsEnv } = useUsEnv();

  const [isShowingTransactionDetails, setIsShowingTransactionDetails] = useState(false);

  const [cardIsFlipped, setCardIsFlipped] = useState(false);
  const [isShowingCardSettingsModal, setIsShowingCardSettingsModal] = useState(false);
  const [isShowingCardCurrencyModal, setIsShowingCardCurrencyModal] = useState(false);
  const [isShowingGalileoCardModal, setShowingGalileoCardModal] = useState(false);
  const [isShowingConnectFinancialDetailsModal, setShowingConnectFinancialDetailsModal] =
    useState(false);
  const [isShowingCardInfoBanner, setShowingCardInfoBanner] = useState(
    getUserBannerInfo() === 'false'
  );

  const [isShowingCryptodraftInfoBanner, setShowingCryptoDraftInfoBanner] = useState(
    getCryptodraftBannerInfo() !== 'false'
  );
  const [isShowingEnableCardModal, setShowingEnableCardModal] = useState(false);

  const [showSecretAccountInfo, setShowSecretAccountInfo] = useState(false);

  const [transactionDetails, setTransactionDetails] = useState({});

  const [loyaltyProgramInfoPopupShow, setLoyaltyProgramInfoPopupShow] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentScreen, setCurrentScreen] = useState('');

  const [isCashbackChanged, setCashbackChanged] = useState(false);
  const [isUserHasTransaction, setUserHasTransaction] = useState(false);

  const showScreen = (screen) => {
    setCurrentScreen(screen);
    setIsModalVisible(true);
  };

  const cardTermsInfoOptions = {
    title: translate('terms_of_card_label'),
    content: () => (
      <div className="mt-4">
        <p className="text-white text-f5">{translate('us_bank_disclaimer_visa_2')}</p>
      </div>
    ),
    isButtonInFooter: false,
    isScrollable: false,
  };

  const cardInfoBannerOptions = {
    content: () => <CardInfoBanner />,
    isButtonInFooter: false,
    isScrollable: true,
  };

  const cardCryptoDraftBannerOptions = {
    content: () => <CardInfoBanner isCryptoDraftBannerEnabled />,
    isButtonInFooter: false,
    isScrollable: false,
  };

  const pendingCardInfoOptions = {
    content: () => (
      <div className="mt-2">
        <p className="text-white text-f5 mb-3">{translate('pending_card_info_note')}</p>
      </div>
    ),
    isButtonInFooter: false,
    isScrollable: true,
  };

  const [showLoyaltyProgramModal, setShowLoyaltyProgramModal] = useState(false);

  const { data: userRegionSettings, isLoading: isLoadingUserRegionSettings } = useQuery(
    USER_REGION_SETTINGS_QUERY_KEY
  );

  const isCryptodraftAllowed = useMemo(
    () => (userRegionSettings?.can_request_cryptodraft && allowCryptodraftFeature) || false,
    [userRegionSettings, allowCryptodraftFeature]
  );

  const [allowLoyaltyProgramToggle] = useSetting('app_features', 'feature_use_loyalty_program');

  const [allowCashbackPayoutOnDemand] = useSetting(
    'app_features',
    'allow_cashback_payout_on_demand'
  );

  const [enableCardPaymentBanner] = useSetting(
    'ui_features_toggles',
    'feature_enable_setup_card_payment_services_banner'
  );

  const [enablePasswordKMSEncryption] = useSetting(
    'app_features',
    'feature_toggle_enable_password_kms_encryption',
    false,
    false
  );

  const { data: publicKeyData } = useQuery(PASSWORD_PUBLIC_KEY, {
    enabled: !!enablePasswordKMSEncryption,
  });

  useEffect(() => {
    if (enablePasswordKMSEncryption && publicKeyData && password) {
      const encryptPassword = async () => {
        try {
          const preparedPassword = await encryptWithPublicKey(publicKeyData?.publicKey, password);
          setEncryptedPassword(preparedPassword);
        } catch (error) {
          // console.error(error);
        }
      };
      encryptPassword();
    }
  }, [enablePasswordKMSEncryption, publicKeyData, password]);

  const isUSVersion = useMemo(() => process.env.REACT_APP_MINIMIZED_US_VERSION === 'true', []);

  const allowLoyaltyProgram = useMemo(
    () => !!(userRegionSettings?.allow_loyalty_program && allowLoyaltyProgramToggle),
    [allowLoyaltyProgramToggle, userRegionSettings]
  );

  const [uiFeatureInfobannerCardPage] = useSetting(
    'ui_features_toggles',
    'ui_feature_infobanner_card_page'
  );

  const [securityNumbersForm, setSecurityNumbersForm] = useReducer(
    (prev, next) => ({ ...prev, ...next }),
    {
      pan: '',
      cvc: '',
      isLoadingCvv: '',
      isLoadingPan: '',
      cvcError: null,
      panError: null,
    }
  );

  const toggle = (type) => {
    switch (type) {
      case cardPopups.ACTIVATE:
        setIsShowingActivateFlow((prev) => !prev);
        break;
      case cardPopups.TRANSACTION_DETAILS:
        setIsShowingTransactionDetails(!isShowingTransactionDetails);
        break;
      case cardPopups.CVV_PAN:
        setIsShowingGetCvvAndPanModal((prev) => !prev);
        break;
      case cardPopups.CARD_GALILEO_BACK_SIDE:
        setShowingGalileoCardModal((prev) => !prev);
        break;
      case cardPopups.CARD_CONNECT_FINANCIAL_DETAILS:
        setShowingConnectFinancialDetailsModal((prev) => !prev);
        break;
      case cardPopups.ENABLE_CARD:
        setShowingEnableCardModal((prev) => !prev);
        break;
      case cardPopups.PIN:
        setIsShowingPinModal((prev) => !prev);
        break;
      case cardPopups.SET_PIN:
        history.push('/dashboard/card/settings', {
          initScreen: cardSettingsScreens.VERIFY_PASSWORD,
        });
        break;
      default:
        break;
    }
  };

  const { isLoading: isLoadingDetails, refetch: getDetails } = useQuery(
    [
      MASTERCARD_MONAVATE_DETAILS,
      { password: enablePasswordKMSEncryption ? encryptedPassword : encodeURI(password) },
    ],
    {
      onSettled(data, error) {
        if (error) {
          setSecurityNumbersForm({ ...securityNumbersForm, cvcError: error, panError: error });
          showAlert({ message: error.message, type: 'danger' });
        } else if (data) {
          setSecurityNumbersForm({
            ...securityNumbersForm,
            cvc: data?.cvv,
            pan: data?.pan,
            cvcError: null,
            panError: null,
          });
          setShowSecretAccountInfo(true);
          toggle(cardPopups.CVV_PAN);
        }
      },
      enabled: false,
    }
  );

  const clearSecurityNumberForm = () => {
    setSecurityNumbersForm({
      pan: '',
      cvc: '',
      isLoadingCvv: '',
      isLoadingPan: '',
      cvcError: null,
      panError: null,
    });
  };

  useEffect(() => {
    setSecurityNumbersForm({
      ...securityNumbersForm,
      isLoadingPAN: isLoadingDetails,
      isLoadingCVC: isLoadingDetails,
    });
  }, [isLoadingDetails]);

  const showCardInfoScreen = (screen) => {
    setCurrentScreen(screen);
  };

  useEffect(() => {
    if (isMobile) {
      showCardInfoScreen(cardPopups.SHOW_CARD_INFO);
    }
  }, [isMobile]);

  const {
    data: linkedWallets,
    refetch: refetchLinkedWallets,
    isLoading: isLoadingLinkedWallets,
  } = useQuery(CARD_LINKED_WALLETS);
  const { data: rates, isLoading: isLoadingRates } = useQuery(RATES_QUERY_KEY);

  const {
    data: pinExist,
    refetch: refetchCheckPIN,
    isLoading: isLoadingPINCheck,
  } = useQuery(CARD_MONAVATE_PIN_CHECK, {
    enabled: false,
  });

  const { data: cardInterestPayment, isLoading: isLoadingCardInterestPayment } = useQuery(
    CARD_INTEREST_PAYMENT_CRYPTODRAFT
  );

  const { data: userPref } = useQuery(USER_PREFERENCES);
  const userDisplayCurrency = userPref?.displayCurrency || 'EUR';

  const {
    data: cardCryptodraftDetails,
    error: cryptodraftError,
    refetch: refetchCryptodraftDetails,
    isLoading: isLoadingCardCryptodraftDetails,
  } = useQuery(CARD_CRYPTODRAFT);

  const cardHasInterestPayments = useMemo(
    () => cardInterestPayment && cardInterestPayment.length > 0,
    [cardInterestPayment]
  );
  const {
    data: cardStatus,
    refetch: refetchCardStatus,
    isLoading: isLoadingCardStatus,
  } = useCardStatus({
    enabled: false,
    onSettled: (_, error) => {
      if (error) {
        // If user doesn't have a card, it's not an error
        if (error.status !== 404 && error.status !== 403) {
          history.push(`/dashboard/card/error`, { cardHasIssue: true });
        }
      } else if (!isGalileoCardReady && cardProvider === cardProviders.GALILEO) {
        setIsGalileoCardReady(true);
      }
    },
  });

  const cardNetwork = useMemo(
    () => resolveCardNetwork(cardProvider, cardStatus),
    [cardProvider, cardStatus]
  );

  const cardCurrencyNoteInfoOptions = {
    content: () => (
      <p>
        {translate('card_currency_note', {
          cardCurrency:
            cardStatus?.cardCurrency?.toUpperCase() || cardStatus?.currency?.toUpperCase(),
          type: cardNetwork,
        })}
      </p>
    ),
    isButtonInFooter: false,
    isScrollable: true,
  };

  const {
    refetch: refetchCashbackData,
    data: cashbackData,
    isLoading: isLoadingCashbackData,
  } = useQuery(CARD_LOAD_CASHBACK, {
    enabled: allowLoyaltyProgram,
  });

  const {
    data: cardInfo,
    refetch: refetchCardInfo,
    isLoading: isLoadingCardInfo,
  } = useCardBalances({
    enabled: false,
  });

  // this value just for accurate calculations when trying to get specific rate based on Monavate display currency
  const principalCurrency = useMemo(() => {
    if (cardStatus?.displayCurrency?.toLowerCase() === BANK_REQUESTS_COINS.EUR) {
      return BANK_REQUESTS_COINS.EUROC;
    }
    if (cardStatus?.displayCurrency?.toLowerCase() === BANK_REQUESTS_COINS.USD) {
      return BANK_REQUESTS_COINS.USDT;
    }
    return cardStatus?.displayCurrency;
  }, [cardStatus?.displayCurrency, cardProvider]);

  const displayCurrencyRate = useRate(cardInfo?.currency, principalCurrency);

  useEffect(() => {
    refetchCardInfo();
    clearSecurityNumberForm();
    refetchLinkedWallets();
    refetchCryptodraftDetails();
    refetchCashbackData();
  }, []);

  useEffect(() => {
    if (cardProvider !== cardProviders.GALILEO) {
      refetchCardStatus();
    }
    if (cardProvider === cardProviders.MONAVATE && cardStatus?.isVirtualCard) {
      refetchCheckPIN();
    }
  }, [cardStatus, cardProvider]);

  const cardBalance = useMemo(() => {
    if (cardProvider && cardInfo && linkedWallets && rates) {
      let onCardBalance = 0.0;
      if (cardProvider === cardProviders.MONAVATE) {
        onCardBalance =
          cardInfo?.availableBalance?.amount > 0 ? cardInfo?.availableBalance?.amount : 0.0;
      } else {
        onCardBalance = cardInfo?.balance || 0.0;
      }

      let linkedWalletBalance = 0;
      linkedWallets.forEach((wallet) => {
        let cardCurrency;

        switch (cardProvider) {
          case cardProviders.MONAVATE:
            cardCurrency = cardStatus?.cardCurrency;
            break;

          default:
            cardCurrency = cardStatus?.currency?.toUpperCase() || 'USD';
        }

        let rate = 1;
        if (wallet?.coin.toUpperCase() !== cardCurrency?.toUpperCase()) {
          rate =
            BigNumber(rates[`${wallet?.coin?.toUpperCase()}${cardCurrency?.toUpperCase()}`]?.ask) ||
            0.0;
        }

        if (!wallet?.is_cryptodraft) {
          linkedWalletBalance +=
            wallet?.available_balance * rate * currencies[wallet?.coin]?.conversion;
        } else {
          let cryptodraftAvaiableBalance =
            wallet?.available_balance * currencies[wallet?.coin]?.conversion;
          if (cardProvider === cardProviders.MONAVATE) {
            let cryptodraftToCardCurrencyRate = 1;
            if (rates[`${wallet?.coin?.toUpperCase()}${cardCurrency?.toUpperCase()}`]?.ask) {
              cryptodraftToCardCurrencyRate = BigNumber(
                rates[`${wallet?.coin?.toUpperCase()}${cardCurrency?.toUpperCase()}`]?.ask
              );
            }
            cryptodraftAvaiableBalance *= cryptodraftToCardCurrencyRate;
          }

          linkedWalletBalance += cryptodraftAvaiableBalance > 0 ? cryptodraftAvaiableBalance : 0;
        }
      });

      return linkedWalletBalance + onCardBalance;
    }
    return 0;
  }, [
    cardInfo,
    cardProvider,
    userDisplayCurrency,
    linkedWallets,
    rates,
    cardCryptodraftDetails,
    displayCurrencyRate,
    isLoadingCardProvider,
  ]);

  const openCryptodraftHandler = (e) => {
    setIsShowingCardSettingsModal(false);
    e.target.closest('html').classList.remove('overflow-hidden');
    setIsShowingPinModal(false);
    if (cardCryptodraftDetails) {
      history.push('/dashboard/card/cryptodraft', {
        initScreen: cryptodraftScreens.DETAILS,
      });
    }
  };

  const { data: enabledLedgerFilteredCurrenciesForLoyaltyProgram } =
    useLedgerFilteredAllowedCreationCurrencies([
      SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
      {
        allow_as_cashback_reward: true,
      },
    ]);

  const { isLoading: isAllWalletsLoading, data: wallets } = useLedgerFilteredWallets(WALLETS_ALL, {
    onSettled(_, error) {
      if (error) {
        showAlert({ message: error.message, type: 'danger' });
      }
    },
  });

  const checkedWallets = useMemo(() => {
    if (isAllWalletsLoading) return [];
    return wallets.map((wallet) => wallet.coin.toUpperCase());
  }, [isAllWalletsLoading]);

  const showSetPinAlert = useMemo(
    () =>
      cardProvider === cardProviders.MONAVATE &&
      cardStatus?.isVirtualCard &&
      !isLoadingPINCheck &&
      !pinExist?.success,
    [cardProvider, cardStatus, isLoadingPINCheck, pinExist]
  );

  const setUserBannerInfo = () => {
    cacheUserBannerInfo();
    setShowingCardInfoBanner(true);
  };

  const setCryptodraftBannerInfo = () => {
    hideCryptodraftBannerInfo();
    setShowingCryptoDraftInfoBanner(false);
  };

  const renderLoyaltyProgramInfoPopup = () => (
    <div
      style={{
        right: allowCashbackPayoutOnDemand ? (isMobile ? '0.675rem' : '-4.675rem') : '-15.375rem',
        top: allowCashbackPayoutOnDemand ? (isMobile ? '5rem' : '1rem') : 0,
        width: '14.375rem',
      }}
      className="position-absolute shadow p-3 bg-disabled rounded border-1 text-center popup-info custom-popup-info">
      <i
        className="d-none d-md-block position-absolute shadow custom-popup-info-arrow"
        style={{ top: 40, left: -8, marginTop: '-1rem' }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="15"
          viewBox="0 0 8 15"
          fill="none">
          <path d="M0 7.88574L8 14.8857L8 0.885742L0 7.88574Z" fill={MAIN_ICON_COLORS.INFO_ARROW} />
        </svg>
      </i>

      <p className="text-white text-f6 text-start">
        {allowCashbackPayoutOnDemand
          ? translate(
              isUsEnv
                ? 'loyalty_program_popup_info_text_claim_us_reward'
                : 'loyalty_program_popup_info_text_claim_reward'
            ).replace('__CURRENCY__', cashbackData?.cashback_currency)
          : translate(
              isUsEnv ? 'loyalty_program_popup_info_us_text' : 'loyalty_program_popup_info_text'
            ).replace('__CURRENCY__', cashbackData?.cashback_currency)}
      </p>
    </div>
  );

  const renderDisclaimer = () => (
    <div className="col-lg-4 col-12 px-0 text-f7 text-shadow" style={{ marginTop: '2.5rem' }}>
      <div>{translate('us_bank_disclaimer_visa_2')}</div>
    </div>
  );

  const showActivateAlert = shouldShowActivateAlert(cardProvider, cardStatus, userRegionSettings);

  const handleFlipCard = () => {
    const flipTarget = resolveCardFlipTarget(cardProvider, isUsUser);
    if (flipTarget === cardFlipTargets.CONNECT_FINANCIAL_DETAILS) {
      setShowingConnectFinancialDetailsModal(true);
    } else if (flipTarget === cardFlipTargets.GALILEO_DETAILS) {
      setShowingGalileoCardModal(true);
    } else {
      setCardIsFlipped((prev) => !prev);
    }
    clearSecurityNumberForm();
  };

  const showEnableCardAlert =
    cardProvider === cardProviders.GALILEO &&
    !cardStatus?.isVirtualCard &&
    cardStatus?.block_card_present_transactions;

  // this functionality will be just for the first visit to main card screen after ordering Mastercard
  const flipMastercardTimerRef = useRef(null);

  useEffect(() => {
    if (history?.location?.state && history?.location?.state?.firstVisitToCardScreen) {
      setCardIsFlipped(true);
      flipMastercardTimerRef.current = setTimeout(() => setCardIsFlipped(false), 3000);
    }
  }, [history?.location?.state?.firstVisitToCardScreen]);

  const [caschbackFormattedDisplayCurrency, setCaschbackDisplayCurrencyAmount] = useState('');
  const conversionRate = useRate(cashbackData?.cashback_currency, userDisplayCurrency, true);
  const currency = currencies[cashbackData?.cashback_currency?.toUpperCase()];
  const caschbackDisplayCurrencyAmount =
    cashbackData?.total_reward_amount * conversionRate * currency.conversion;
  useEffect(() => {
    setCaschbackDisplayCurrencyAmount(
      formatNumber(caschbackDisplayCurrencyAmount, currencies[userDisplayCurrency].decimal)
    );
  }, [caschbackDisplayCurrencyAmount, userDisplayCurrency]);

  useEffect(
    () => () => {
      clearTimeout(flipMastercardTimerRef.current);
      if (history.location.state && history.location.state.firstVisitToCardScreen) {
        const stateVar = { ...history.location.state };
        delete stateVar.firstVisitToCardScreen;
        history.replace({ ...history.location, stateVar });
      }
    },
    [history]
  );

  useEffect(() => {
    if (cardIsFlipped && cardStatus?.cardState === CardState.BLOCKED) {
      setCardIsFlipped(false);
    }
  }, [cardIsFlipped, cardStatus?.cardState]);

  useEffect(() => {
    if (locationState?.galileoCardUnderPreparing) {
      const timeoutId = setTimeout(() => {
        refetchCardStatus();
        refetchCardInfo();
      }, 8000);
      return () => clearTimeout(timeoutId);
    }
    return () => {};
  }, []);

  if (getShowCardHint() === 'true') {
    return <Redirect to="/hint/card" />;
  }

  const showCryptodraftBanner =
    !cardCryptodraftDetails &&
    isShowingCryptodraftInfoBanner &&
    isCryptodraftAllowed &&
    isUserHasTransaction &&
    (isShowingCardInfoBanner || !uiFeatureInfobannerCardPage);

  const isLoadingCardDetailsPage =
    (cardProvider === cardProviders.GALILEO && !isGalileoCardReady) ||
    isLoadingCardInfo ||
    isLoadingLinkedWallets ||
    isLoadingCardProvider ||
    isLoadingPINCheck ||
    isLoadingLinkedWallets ||
    isAllWalletsLoading ||
    isLoadingRates ||
    isLoadingCardInterestPayment ||
    isLoadingCardStatus ||
    isLoadingCardCryptodraftDetails ||
    isLoadingCashbackData ||
    isLoadingUserRegionSettings;

  return (
    <CardLayout>
      {!showSearchModal && (
        <div className="col-12 col-md-4 px-3 px-md-0 mt-0 mt-md-4">
          {/* Mobile layout */}
          <div className="d-flex d-md-none flex-row justify-content-between align-items-end mb-3">
            <p className="text-f3">{translate('card_tab_label')}</p>
            <div className="d-flex flex-row">
              {!isUSVersion && process.env.REACT_APP_FLAVOR !== '1inch' && (
                <div
                  onClick={(e) => {
                    e.target.closest('html').classList.add('overflow-hidden');
                    setIsShowingCardSettingsModal(true);
                  }}
                  onKeyDown={() => {}}
                  role="presentation"
                  tabIndex={-1}>
                  <i className="icon text-f4 icon-settings-navigation" />
                </div>
              )}
            </div>
          </div>
          <div className="row mx-0">
            <div className="px-0 col-12">
              <div className="d-flex flex-row justify-content-md-start">
                <div className="w-100 d-flex mb-3 mb-md-0 flex-column justify-content-center align-items-center">
                  <ReactCardFlip
                    isFlipped={cardIsFlipped}
                    flipDirection="horizontal"
                    containerStyle={{ maxWidth: '26rem', width: '100%' }}
                    containerClassName="d-flex justify-content-center">
                    <Card
                      loading={isLoadingCardDetailsPage}
                      amount={formatNumber(cardBalance, exchange.FIAT_VALUE)}
                      currency={cardInfo?.platform}
                      flip={handleFlipCard}
                      openCardSettingModal={() => setIsShowingCardSettingsModal(true)}
                      openCardCurrencyNote={() => setIsShowingCardCurrencyModal(true)}
                      cardStatus={cardStatus}
                      cardProvider={cardProvider}
                      toggelPendingCardInfo={() => showScreen(cardPopups.PENDING_CARD_INFO)}
                    />
                    {cardStatus?.cardState !== CardState.BLOCKED &&
                      (cardStatus?.isVirtualCard ? (
                        <div>
                          <VirtualCardBack
                            details={cardStatus}
                            openCardSettingModal={() => setIsShowingCardSettingsModal(true)}
                            flip={() => {
                              setCardIsFlipped((prev) => !prev);
                              clearSecurityNumberForm();
                            }}
                            toggleCvvModal={() => toggle(cardPopups.CVV_PAN)}
                            isShowSecretInfo={showSecretAccountInfo}
                            showSecretInfo={setShowSecretAccountInfo}
                            securityNumbersForm={securityNumbersForm}
                          />
                        </div>
                      ) : (
                        <div>
                          <ActiveCardBack
                            details={cardStatus}
                            openCardSettingModal={() => setIsShowingCardSettingsModal(true)}
                            flip={() => {
                              setCardIsFlipped((prev) => !prev);
                              clearSecurityNumberForm();
                            }}
                            toggleCvvModal={() => toggle(cardPopups.CVV_PAN)}
                            togglePinModal={() => toggle(cardPopups.PIN)}
                            isShowSecretInfo={showSecretAccountInfo}
                            showSecretInfo={setShowSecretAccountInfo}
                            securityNumbersForm={securityNumbersForm}
                          />
                        </div>
                      ))}
                  </ReactCardFlip>

                  {isLoadingCardDetailsPage && (
                    <div className="d-flex flex-column w-100 gap-3 mt-4">
                      <SettingButtonPlaceholder />
                      <SettingButtonPlaceholder />
                    </div>
                  )}

                  {!isLoadingCardDetailsPage &&
                    ![CardState.LOST, CardState.STOLEN, CardState.DISABLED].includes(
                      cardStatus?.cardState
                    ) && (
                      <div className="d-flex flex-column w-100">
                        {!isUSVersion && cardCryptodraftDetails && !cryptodraftError && (
                          <CardCryptodraftDetails
                            details={cardCryptodraftDetails}
                            cardStatus={cardStatus}
                            openModal={() =>
                              history.push('/dashboard/card/cryptodraft', {
                                initScreen: cryptodraftScreens.DETAILS,
                              })
                            }
                          />
                        )}
                        {showSetPinAlert && (
                          <div
                            className="alert alert-warning my-0 alert-action mt-4 d-flex flex-row align-items-center justify-content-between"
                            role="button"
                            tabIndex="0"
                            onClick={() => toggle(cardPopups.SET_PIN)}
                            onKeyDown={() => toggle(cardPopups.SET_PIN)}>
                            <div className="d-flex flex-row">
                              <i className="icon icon-attention-other text-f4 mt-1" />
                              <span className="content text-f6 px-2 px-md-0">
                                {translate('monavate_set_pin_note')}
                              </span>
                            </div>
                            <i className="icon icon-arrow-next-navigation " />
                          </div>
                        )}
                        {!isUSVersion && (!cardCryptodraftDetails || cryptodraftError) && (
                          <CardOptions
                            cardStatus={cardStatus}
                            isCryptodraftAllowed={isCryptodraftAllowed}
                          />
                        )}

                        {showEnableCardAlert && (
                          <div
                            className="alert alert-warning alert-action mt-lg-4 d-flex flex-row align-items-center justify-content-between"
                            role="button"
                            tabIndex="0"
                            onClick={() => toggle(cardPopups.ENABLE_CARD)}
                            onKeyDown={() => toggle(cardPopups.ENABLE_CARD)}>
                            <div className="d-flex flex-row">
                              <i className="icon icon-attention-other text-f4 mt-1" />
                              <span className="content text-f6 px-0 px-md-2">
                                {translate('enable_card_alert_info')}
                              </span>
                            </div>
                            <i className="icon icon-arrow-next-navigation " />
                          </div>
                        )}

                        {allowLoyaltyProgram && (
                          <div className="position-relative">
                            {allowCashbackPayoutOnDemand ? (
                              <LoyaltyProgramNewUi
                                onClick={() => {
                                  history.push('/dashboard/card/loyalty', {
                                    initScreen: cashbackData?.cashback_currency
                                      ? loyaltyScreens.CLAIM_REWARD
                                      : loyaltyScreens.SELECT_CASHBACK,
                                    allowedCurrencies:
                                      enabledLedgerFilteredCurrenciesForLoyaltyProgram,
                                    cashbackData,
                                  });
                                }}
                                className="mt-3 position-relative"
                                label={translate('loyalty_program_label')}
                                subLabel={translate('loyalty_program_sublabel')}
                                cashbackDisplayAmount={translate(
                                  isUsEnv
                                    ? 'loyalty_program_available_us_cashback'
                                    : 'loyalty_program_available_cashback'
                                )
                                  .replace('__DISPLAY_AMOUNT__', caschbackFormattedDisplayCurrency)
                                  .replace('__CURRENCY__', userDisplayCurrency)}
                                image="gift"
                                onClickRightImage={() =>
                                  setLoyaltyProgramInfoPopupShow(!loyaltyProgramInfoPopupShow)
                                }
                                rightImage={cashbackData ? 'icon-question-other' : null}
                                cashbackData={cashbackData}
                                onInfoIconMouseEnter={() =>
                                  setLoyaltyProgramInfoPopupShow(!loyaltyProgramInfoPopupShow)
                                }
                                onInfoIconMouseLeave={() =>
                                  setLoyaltyProgramInfoPopupShow(!loyaltyProgramInfoPopupShow)
                                }
                              />
                            ) : (
                              <LoyaltyProgram
                                onClick={() => setShowLoyaltyProgramModal(true)}
                                className="mt-3 position-relative"
                                label={translate('loyalty_program_label')}
                                subLabel={translate('loyalty_program_sublabel')}
                                image="loyalty_program"
                                rightImage={cashbackData ? 'icon-question-other' : null}
                                cashbackData={cashbackData}
                                onInfoIconMouseEnter={() => setLoyaltyProgramInfoPopupShow(true)}
                                onInfoIconMouseLeave={() => setLoyaltyProgramInfoPopupShow(false)}
                              />
                            )}
                            {loyaltyProgramInfoPopupShow && renderLoyaltyProgramInfoPopup()}
                          </div>
                        )}
                        {enableCardPaymentBanner && <PaymentBanner />}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="col-12 px-0">
              {!isLoadingCardDetailsPage && showActivateAlert && (
                <div
                  className="alert alert-warning alert-action mt-lg-4"
                  role="button"
                  tabIndex="0"
                  onClick={() => toggle(cardPopups.ACTIVATE)}
                  onKeyDown={() => toggle(cardPopups.ACTIVATE)}>
                  <i className="icon icon-attention-other" />
                  <span className="content px-2 px-md-0">
                    {translate('card_activate_note_message')}
                  </span>
                  <i className="icon icon-arrow-next-navigation" />
                </div>
              )}
              {!isLoadingCardDetailsPage && cardHasInterestPayments && (
                <div
                  role="button"
                  tabIndex="0"
                  onClick={(e) => {
                    if (isMobile) {
                      e.target.closest('html').classList.add('overflow-hidden');
                    }
                    history.push('/dashboard/card/cryptodraft', {
                      initScreen: cryptodraftScreens.INTEREST_PAYMENTS,
                    });
                  }}
                  onKeyDown={(e) => {
                    if (isMobile) {
                      e.target.closest('html').classList.add('overflow-hidden');
                    }
                    history.push('/dashboard/card/cryptodraft', {
                      initScreen: cryptodraftScreens.INTEREST_PAYMENTS,
                    });
                  }}
                  className="alert alert-info alert-action mt-lg-4">
                  <i className="icon icon-info-icon" />
                  <span className="content px-2 px-md-0">
                    {translate('card_have_interest_payment_note')}
                  </span>
                  <i className="icon icon-arrow-next-navigation text-right flex-fill" />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="col-12 col-md-8 pt-4 pt-md-0 px-md-0 py-md-0 ps-md-4 card-transaction-container">
        {!isLoadingCardDetailsPage && !isShowingCardInfoBanner && uiFeatureInfobannerCardPage && (
          <div className="d-none d-md-block">
            <CardInfoBanner onCloseClick={setUserBannerInfo} isCryptoDraftBannerEnabled={false} />
          </div>
        )}
        {!isLoadingCardDetailsPage && showCryptodraftBanner && (
          <div className="d-none d-md-block">
            <CardInfoBanner onCloseClick={setCryptodraftBannerInfo} isCryptoDraftBannerEnabled />
          </div>
        )}

        <CardTransactions
          showDetails={() => toggle(cardPopups.TRANSACTION_DETAILS)}
          setDetails={setTransactionDetails}
          onShowSearchInput={setShowSearchModal}
          isLoadingCardDetailsPage={isLoadingCardDetailsPage}
          isCashbackChanged={isCashbackChanged}
          setCashbackChanged={setCashbackChanged}
          setUserHasTransaction={setUserHasTransaction}
          openCardSettingModal={() => setIsShowingCardSettingsModal(true)}
          isReplacementRequested={cardStatus?.is_replacement_requested || false}
          isMiddleSize
        />
      </div>
      {isShowingActivateFLow && <ActivateCardModal hide={() => toggle(cardPopups.ACTIVATE)} />}
      {isShowingTransactionDetails && (
        <CardTransactionDetailsModal
          hide={() => toggle(cardPopups.TRANSACTION_DETAILS)}
          details={transactionDetails}
        />
      )}
      {isShowingGetCvvAndPanModal && (
        <ViewCvvAndPanModal
          hide={() => toggle(cardPopups.CVV_PAN)}
          setPassword={setPassword}
          getDetails={getDetails}
          isLoadingDetails={isLoadingDetails}
        />
      )}
      {isShowingPinModal && (
        <CardSettingsModal
          hide={() => setIsShowingPinModal(false)}
          cardStatus={cardStatus}
          cardProvider={cardProvider}
          enableCryptodraft={!!cardCryptodraftDetails}
          openCryptodraftModal={openCryptodraftHandler}
          defaultScreen={manageCardScreens.PIN_SETTINGS}
        />
      )}
      {isShowingCardSettingsModal && (
        <CardSettingsModal
          hide={() => setIsShowingCardSettingsModal(false)}
          cardStatus={cardStatus}
          cardProvider={cardProvider}
          enableCryptodraft={!!cardCryptodraftDetails}
          openCryptodraftModal={openCryptodraftHandler}
        />
      )}
      {isShowingGalileoCardModal && (
        <CardGalileoBackSideModal hide={() => toggle(cardPopups.CARD_GALILEO_BACK_SIDE)} />
      )}
      {isShowingConnectFinancialDetailsModal && (
        <CardConnectFinancialDetailsModal
          hide={() => toggle(cardPopups.CARD_CONNECT_FINANCIAL_DETAILS)}
        />
      )}
      {isUsUser && cardProvider === cardProviders.GALILEO ? renderDisclaimer() : <></>}

      {showLoyaltyProgramModal && allowLoyaltyProgram && (
        <LoyaltyProgramModal
          setCashbackChanged={setCashbackChanged}
          checkedWallets={checkedWallets}
          allowedCurrencies={enabledLedgerFilteredCurrenciesForLoyaltyProgram}
          hide={() => {
            setShowLoyaltyProgramModal(false);
            refetchCashbackData();
          }}
        />
      )}
      {isShowingEnableCardModal && <EnableCardModal hide={() => toggle(cardPopups.ENABLE_CARD)} />}
      <ModalLayout
        onHide={() => setIsModalVisible(false)}
        isVisible={isModalVisible}
        modalHeight="h-95vh"
        currentScreen={currentScreen}>
        <InfoPopup keyName={cardPopups.CARD_TERMS} options={cardTermsInfoOptions} />
        <InfoPopup keyName={cardPopups.PENDING_CARD_INFO} options={pendingCardInfoOptions} />
      </ModalLayout>

      <ModalLayout
        onHide={setUserBannerInfo}
        isVisible={!isShowingCardInfoBanner && isMobile && uiFeatureInfobannerCardPage}
        currentScreen={currentScreen}>
        <InfoPopup keyName={cardPopups.SHOW_CARD_INFO} options={cardInfoBannerOptions} />
      </ModalLayout>

      <ModalLayout
        onHide={() => setIsShowingCardCurrencyModal(false)}
        isVisible={isShowingCardCurrencyModal && isMobile}
        currentScreen={currentScreen}>
        <InfoPopup keyName={cardPopups.SHOW_CARD_INFO} options={cardCurrencyNoteInfoOptions} />
      </ModalLayout>

      <ModalLayout
        onHide={setCryptodraftBannerInfo}
        isVisible={showCryptodraftBanner && isMobile}
        modalHeight="h-95vh"
        currentScreen={currentScreen}>
        <InfoPopup keyName={cardPopups.SHOW_CARD_INFO} options={cardCryptoDraftBannerOptions} />
      </ModalLayout>
    </CardLayout>
  );
};

export default CardManager;
